import RefDetail from "../RefDetail";
import { IWebSearch } from "logic/src/objects/chat/types";
import { ReactComponent as CloseIcon } from "logic/src/components/icons/close.svg";
import styles from "./styles.module.scss";

interface IProps {
  list: IWebSearch[];
  onClose: () => void;
}

const RefList = ({ list, onClose }: IProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {`找到了 ${list.length} 篇资料作为参考`}
        <CloseIcon onClick={onClose} className={styles.closeIcon} />
      </div>
      <div className={styles.body}>
        {list.map((content, index) => {
          return (
            <RefDetail
              className={styles.item}
              key={content.url + content.title}
              title={content.title || "引用内容"}
              content={content.passage_or_snippet}
              url={content.url}
              icon={content.icon}
              domain={content.domain}
              index={(index + 1).toString()}
            />
          );
        })}
      </div>
    </div>
  );
};
export default RefList;
